import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Prduction'

  }
];

@Component({
  selector: 'page-production-check-sheet',
  templateUrl: './form-production-check-sheet.html',
  styleUrls: ['./form-production-check-sheet.scss']
})

export class PageProductionCheckSheet implements OnInit {
  //initial & Search
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  loadingIndicator: boolean = true;
  key: any; data: any;
  lines = []; prods = []; checkpoints = []; valuesFirst = []; valuesMidle = []; valuesEnd = [];
  tpr_id: String;tpr_name:String; tpn_id: String;tpn_name:String;
  lineName: String; processName: String;
  rowsSpan: any = 0;
  //dialog
  dialogRefWarning: MdDialogRef<WarningPdCheckSheetDialog>;
  dialogRef: MdDialogRef<pdCheckSheetDialog>;
  setId: any;
  dateTime: any; date_selected: any;
  fpoint = []; mpoint = []; epoint = []; models = [];
  firstCheck: boolean = false; middleCheck: boolean = false; endCheck: boolean = false;
  operatorName: String; prodDate: String; operatorId: String; tb87f_id: String; tb106f_id: String;
  tp_id_ctl = new FormControl();
  tp_id:String;
  sysPath: String = environment.sysPath;
  ckSave: Boolean = false;
  shift:any=1;
  dropdownList = [];
  selectedItems = [];
  dropdownListModel = [];
  selectedItemsModel = [];
  dropdownSettings = {
    singleSelection: true,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "col-md-12"
  };
  constructor(private fb: FormBuilder, private httpservice: httpservice, private router: Router, public dialog: MdDialog, private _sharedService: SharedService) {
    this.dateTime = Date.now();
    let date = new Date();
    this.date_selected = date.toISOString().split('T')[0];


    /*
    let setDate = ""; let setMonth = "";
    if(date.getDate()<10){
      setDate = "0"+date.getDate().toString();
    }else{
      setDate = date.getDate().toString();
    }

    if((date.getMonth()+1)<10){
      setMonth = "0"+(date.getMonth()+1).toString();
    }else{
      setMonth = (date.getMonth()+1).toString();
    }

    this.date_selected = date.getFullYear().toString()+"-"+setMonth+"-"+setDate;
    let dateCheck: Date = new Date(this.date_selected);
    let dateStart: Date = new Date(this.date_selected+" 00:00:00");
    let dateStop: Date = new Date(this.date_selected+" 07:59:59");

console.log('check time',dateCheck.getTime(),dateStart.getTime(),dateStop.getTime())

  if(dateCheck.getTime() > dateStart.getTime() && dateCheck.getTime()<dateStop.getTime()){
    let dateAssign: Date = new Date(this.date_selected);
    //dateAssign.setDate(dateCheck.getDate() - 1);
    dateAssign.setDate(dateCheck.getDate());
    this.date_selected = dateAssign.toISOString().split('T')[0];
  }
*/
    this.getlines();
    this._sharedService.emitChange(this.pageTitle);
    this.fullScreen();
    this.dialog.closeAll();
  }

  checkFirst(e:any){
    if(e.checked==true){
      this.endCheck = false;
    }else{
      this.firstCheck = true;
    }
    console.log('event',e.checked);
  }
  checkEnd(e:any){
    if(e.checked==true){
      this.firstCheck = false;
    }else{
      this.endCheck = true;
    }
    console.log('event1',e.checked);
  }

  onItemSelect(item: any) {
    //console.log(item);
    this.selectedItemsModel = [];
    this.dropdownListModel = [];

    this.tpr_id = this.selectedItems[0].id;
    this.tpr_name = this.selectedItems[0].itemName;
    console.log('onItemSelect',this.selectedItems,this.tpr_id);

    this.getModel(this.tpr_id);
  }
  onItemSelectModel(item: any) {
    //console.log(item);
    this.tp_id = this.selectedItemsModel[0].id;
    this.getAllProcess();
  }

  OnItemDeSelect(item: any) {
    //console.log(item);
    //console.log(this.selectedItemsProcess);
  }
  onSelectAll(items: any) {
    //console.log(items);
  }
  onDeSelectAll(items: any) {
    //console.log(items);
  }

  getModel(id: String) {
    this.httpservice.fetchget('getJSON_model.php?tpr_id=' + id, data => {
      this.models = data;
      for (let i = 0; i < data.length; i++) {
        this.dropdownListModel.push({ "id": data[i].tp_id, "itemName": data[i].tp_productname +"-"+ data[i].tp_part_no  });
      }
      console.log('model', data);
    });
  }
  fullScreen() {
    let elem = document.documentElement;
    let methodToBeInvoked = elem.requestFullscreen || elem['mozRequestFullscreen']
      ||
      elem['msRequestFullscreen'];
    if (methodToBeInvoked) methodToBeInvoked.call(elem);
  }

  getOperator() {
    this.httpservice.fetchget('getJSON_production_operator.php?tpr_id=' + this.tpr_id + '&tpn_id=' + this.tpn_id, data => {
      this.operatorName = data[0].operator_name;
      this.prodDate = data[0].planDate;
      this.operatorId = data[0].operator_id;
      console.log('operator', data);
    });
  }
  getCheckPoint() {
    this.ckSave = true;
    this.httpservice.fetchget('getJSON_mobile_standard_list.php?type='+this.shift+'&date_selected=' + this.date_selected + '&tp_id=' + this.tp_id + '&tpr_id=' + this.tpr_id + '&tpn_id=' + this.tpn_id, data => {
      this.checkpoints = data;

      for (let i = 0; i < data.length; i++) {
        let a = data[i].process;
        for (let b = 0; b < a.length; b++) {
          this.fpoint[a[b].tb106f_id] = a[b].value_f;
          this.epoint[a[b].tb106f_id] = a[b].value_e;
          this.ckSave = false;
          this.firstCheck = false;
          this.endCheck = false;
          //console.log('checkpoints',this.fpoint);
        }


      }

      //let a = [];
      //if (data.length != 0) {
      //  a = data[0].process;
      //for (let i = 0; i < a.length; i++) {
      //  this.fpoint[i] = a[i].value_f;
      //  this.mpoint[i] = a[i].value_m;
      //  this.epoint[i] = a[i].value_e;
      //  console.log('checkpoints', a[i],data);
      // }
      //}
    });
  }


  intervalGetData() {

    return setInterval(() => {
      if (this.setId.runCount > 5) {
        clearInterval(this.setId);
      }
      //this.getStartData();
      console.log('------this.setId------', this.setId);
    }, 1000);

  }
  getlines() {
    this.httpservice.fetchget('getJSON_line_name.php?', data => {
      this.lines = data;
      for (let i = 0; i < data.length; i++) {
        this.dropdownList.push({ "id": data[i].tpr_id, "itemName": data[i].tpr_name });
      }

    });
  }
  getProcess(id: String, name: string) {
    this.tpn_id = id;
    this.processName = name;
    this.getCheckPoint();
    this.getOperator();

  }

  getAllProcess() {
    this.getCheckPoint();
    this.getOperator();
  }

  getValueInputFirst(value: String, tb87f_id: any, index: any, tb106f_id: any, tpn_id: String) {
    //this.valuesFirst[index] = { value: value, spec: tb87f_id, point: tb106f_id,tpn_id:tpn_id };
    if (this.valuesFirst.length > 0) {
      let i = 0;
      this.valuesFirst.forEach(prop => {
        if (prop.point == tb106f_id) {
          this.valuesFirst.splice(i, 1);
        }
        i++;
      });


        this.valuesFirst.push({ value: value, spec: tb87f_id, point: tb106f_id, tpn_id: tpn_id });
      
     
    } else {

        this.valuesFirst.push({ value: value, spec: tb87f_id, point: tb106f_id, tpn_id: tpn_id });
      
    }

    console.log('value', this.valuesFirst,index);
  }
  getValueInputMidle(value: String, tb87f_id: String, index: any, tb106f_id: String) {
    this.valuesMidle[index] = { value: value, spec: tb87f_id, point: tb106f_id };
    console.log('value', this.valuesMidle, tb87f_id, tb106f_id);
  }
  getValueInputEnd(value: String, tb87f_id: String, index: any, tb106f_id: String, tpn_id: String) {
    //this.valuesEnd[index] = { value: value, spec: tb87f_id, point: tb106f_id ,tpn_id:tpn_id};

    if (this.valuesEnd.length > 0) {
      let i = 0;
      this.valuesEnd.forEach(prop => {
        if (prop.point == tb106f_id) {
          this.valuesEnd.splice(i, 1);
        }
        i++;
      });


        this.valuesEnd.push({ value: value, spec: tb87f_id, point: tb106f_id, tpn_id: tpn_id });
      
      
    } else {

        this.valuesEnd.push({ value: value, spec: tb87f_id, point: tb106f_id, tpn_id: tpn_id });
      
    }
    console.log('value', this.valuesEnd,index);
  }

  save() {
    this.ckSave = true;
    let value = {
      date_selected:this.date_selected,
      tpr_id: this.tpr_id, tpn_id: this.tpn_id, type:this.shift, valuesFirst: this.valuesFirst,
      tp_id: this.tp_id, valuesMidle: this.valuesMidle, valuesEnd: this.valuesEnd,
      firstCheck: this.firstCheck, middleCheck: this.middleCheck, endCheck: this.endCheck,
      user: this.operatorId
    };
    this.httpservice.fetchpost('insertDataMobile_check_point.php', value, (cb) => {
      this.ckSave = false;
      this.firstCheck = false;
      this.endCheck = false;
      //this.getCheckPoint();
    });
  }


  search() {

  }

  ngOnInit() {

  }

}
//dialog
@Component({
  selector: 'pd-check-sheet-dialog',
  templateUrl: 'dialog.html',
})
export class pdCheckSheetDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<pdCheckSheetDialog>) { }
}

//warning
@Component({
  selector: 'warning-pd-check-sheet-dialog',
  templateUrl: 'warning.html',
})
export class WarningPdCheckSheetDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningPdCheckSheetDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/mobile/form-production-check-sheet.ts